import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.6.196C19.4 0 19.1 0 18.8 0l-12 1.956c-.4.098-.8.49-.8.978v10.754H3c-1.7 0-3 1.27-3 2.932s1.3 2.933 3 2.933h2c1.7 0 3-1.27 3-2.933V3.716l10-1.662v9.678h-3c-1.7 0-3 1.271-3 2.933s1.3 2.933 3 2.933h2c1.7 0 3-1.271 3-2.933V.978c0-.293-.1-.587-.4-.782M6 16.619c0 .587-.4.978-1 .978H3c-.6 0-1-.391-1-.978 0-.586.4-.977 1-.977h3zm12-1.955c0 .587-.4.978-1 .978h-2c-.6 0-1-.391-1-.978s.4-.977 1-.977h3z"
    }, null, -1)
  ]))]))
}
export default { render: render }